import { Modal } from "@/shared/ui/Modal";

export const LinksDescriptionModal = ({
  description,
}: {
  description: string | null;
}) => {
  return (
    <Modal>
      <Modal.Trigger disabled={!description} variant="outline">
        Раскрыть
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Описание</Modal.Title>

        <p className="text-textColor first-letter:capitalize">{description}</p>
      </Modal.Content>
    </Modal>
  );
};
